import React from 'react';
import Tooltip from '@srm/ui/tooltip';
import { useIsTruncated } from '../hooks/useIsTruncated';

/**
 * Текст с одной строкой + ellipsis. Tooltip показывается ТОЛЬКО когда контент
 * реально обрезан (см. useIsTruncated).
 *
 * Используется для: имени позиции в шапке, имени оффера в шапке колонки,
 * любого другого «возможно длинного» текста в плотных layout'ах.
 */
export const EllipsisName: React.FC<{ text: string; className?: string }> = ({ text, className }) => {
    const { ref, isTruncated } = useIsTruncated<HTMLSpanElement>(text);

    const node = (
        <span ref={ref} className={className}>
            {text}
        </span>
    );
    if (!isTruncated) return node;
    return (
        <Tooltip
            background="black"
            wrapTarget={false}
            interactive={false}
            openDelay={250}
            position="bottom-start"
            label={text}
        >
            {node}
        </Tooltip>
    );
};
